<template>
  <v-toolbar app>
    <!-- logo -->
    <a href="https://kontinentalist.com/" class="navbar__logo transition--opacity">
      <img
        src="@/assets/img/logo-primary.svg"
        alt="kontinentalist-logo"
        width="180px">
    </a>

    <v-spacer />

    <!-- menu items -->
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
        :ripple="false"
        href="https://kontinentalist.com/about"
        flat
        class="btn--plain">
        About
      </v-btn>
      <v-btn
        :ripple="false"
        href="https://kontinentalist.com/services"
        flat
        class="btn--plain">
        Our Services
      </v-btn>
      <v-btn
        :ripple="false"
        href="https://kontinentalist.com/stories"
        flat
        class="btn--plain">
        Stories
      </v-btn>
      <v-btn
        :ripple="false"
        href="https://medium.com/kontinentalist"
        target="_blank"
        flat
        class="btn--plain">
        Blog
      </v-btn>
      <v-btn
        :ripple="false"
        href="https://kontinentalist.com/map"
        flat
        class="btn--plain">
        Atlas Asia
      </v-btn>
    </v-toolbar-items>

    <!-- hamburger icon -->
  </v-toolbar>
</template>

<script>
export default {
  name: 'TheNavbar',
};
</script>

<style lang="stylus" scoped>
.v-toolbar__items {
  .v-btn {
    width: auto;
    min-width: unset;
  }
}

// transitions
.navbar__logo.transition--opacity {
  opacity: 1;
  transition: opacity 0.3s linear;

  &:hover {
    opacity: 0.7;
  }
}

.btn--plain {
  &.v-btn--active, &:hover, &:focus {
    color: #F2784B;

    &:before {
      background-color: transparent;
    }
  }
}
</style>
